

export const billStatus = [
    { key: 1, label: "Issue", value: "issueDate" },
    { key: 2, label: "Due", value: "dueDate" },
]

export const roleRedirect = {
    Admin: "/admin-dashboard",
    Staffs: "/staff/dashboard",
    Parents: "/parent/dashboard",
};

export const handleType = (tabKey) => {
    if (tabKey === "1") {
        return "child-information"
    } else if (tabKey === "2") {
        return "parents-information"
    } else if (tabKey === "3") {
        return "emergency-information"
    } else if (tabKey === "4") {
        return "auth-pickup"
    } else if (tabKey === "5") {
        return "not-auth-pickup"
    }
}

export const audianceType = ["Teachers", "Parents"]

export const leaveTypes = [
    { id: 1, label: "Sick Leave", value: "sick" },
    { id: 2, label: "Casual Leave", value: "casual" },
    { id: 3, label: "Emergency Leave", value: "emergency" },
    { id: 4, label: "Vacation Leave", value: "vacation" }
]

export const newsStatus = ['Draft', 'Sent', 'Schedule']

export const staffdDetails = [
    { key: "1", label: "Personal Information" },
    { key: "2", label: "Employement Information" },
    { key: "3", label: "Emergency Contact" },
    { key: "4", label: "Upload Documents" },
];

export const activityTypeData = [
    { key: "1", value: "photo", label: "Photo" },
    { key: "2", value: "vedio", label: "Video" },
    { key: "3", value: "learning", label: "Learning" },
    { key: "4", value: "meal", label: "Meal" },
    { key: "5", value: "nap", label: "Nap" },
    { key: "6", value: "bathroom", label: "Bathroom" },
    { key: "7", value: "bottle", label: "Bottle" },
    { key: "8", value: "mood", label: "Mood" },
    { key: "9", value: "meds", label: "Meds" },
    { key: "10", value: "note", label: "Note" },

];
   

export const activitiesKey = {
    photo: "Photo",
    vedio: "Video",
    learning: "Learning",
    meal: "Meal",
    nap: "Nap",
    bathroom: "Bathroom",
    bottle: "Bottle",
    mood: "Mood",
    meds: "Meds",
    note: "Note",
}

export const childDetails = [
    { key: "1", label: "Child Information" },
    { key: "2", label: "Parents  Information" },
    { key: "3", label: "Emergency Contact" },
    { key: "4", label: "Authorised Pickup" },
    { key: "5", label: "Not Authorised pickup" },
    { key: "6", label: "Upload Documents" },
];
export const parentChildDetails = [
    { key: "1", label: "Child Information" },
    { key: "2", label: "Parents  Information" },
    { key: "3", label: "Upload Documents" },
];

export const childrenViewData = [
    { key: "1", value: "child - information", label: "Child Information" },
    { key: "2", value: "parents - details", label: "Parent Information" },
    { key: "3", value: " emergency - information", label: "Emergency Information" },
    { key: "4", value: "auth - pickup", label: "Authorised Pickup" },
    { key: "5", value: "not - auth - pickup", label: "Not-Authorised Pickup" },

]
export const paymentFrequency = [
    { key: 1, value: "Weekly" },
    { key: 2, value: "Biweekly" },
    { key: 3, value: "Monthly" },
    { key: 4, value: "Quaterly" },

]

export const genderType = [
    "Male", "Female", "Other"
]

export const noticePeriod = [
    { key: 1, value: "30 days" },
    { key: 2, value: "45 days" },
    { key: 3, value: "60 days" },
    { key: 4, value: "90 days" },

]

export const staffContractTYpe = [
    { key: 1, value: "Full-Time" },
    { key: 2, value: "Part-Time" },

]

export const childEnrollmentType = [
    { key: 1, value: "Full time" },
    { key: 2, value: "Part time" },

]
export const staffRole = [
    { key: 1, value: "Manager", label: "Manager" },
    { key: 6, value: "AssistantManager", label: "Assistant Manager" },
    { key: 2, value: "HRPayroll", label: "HR Payroll" },
    { key: 3, value: "TeachingStaff", label: "Teaching Staff" },
    { key: 4, value: "KitchenStaff", label: "Kitchen Staff" },
    { key: 5, value: "CleaningStaff", label: "Cleaning Staff" },
]

export const Roles = {
    manager: "Manager",
    assistant: "Assistant Manager",
    hr: "HR Payroll",
    teacher: "Teaching Staff",
    kitchen: "Kitchen Staff",
    cleaning: "Cleaning Staff",
}


export const employmentWorkingPaterns = [
    { key: 1, value: "Morning" },
    { key: 3, value: "Afternoon" },
    { key: 4, value: "Evening" },
]
export const employmentType = [
    { key: 1, value: "Fixed" },
    { key: 2, value: "Permanent" },
    { key: 3, value: "Contract" },
    { key: 4, value: "Temporary" },
]

export const employmentUnit = [
    { key: 1, value: "Hours" },
    { key: 2, value: "Days" },
    { key: 3, value: "Weeks" },
]

export const currencyList = [
    { id: 1, value: "£" },
    { id: 2, value: "€" },
    { id: 3, value: "$" },
]
export const newStatus = {
    Active: "ACTIVE",
    waitlist: "WAITLIST",
    Inactive: "INACTIVE",
    active: "Active",
    inactive: "Inactive",
}

export const mealStatus = {
    Scheduled: "Scheduled",
    Completed: "Completed",
    Active: "Active"
}

export const newLetterStatus = {
    sent: "Sent",
    scheduled: "Schedule",
    draft: "Draft",
}

export const newsLeterData = [
    { id: 1, value: "Sent", label: "Sent" },
    { id: 2, value: "Scheduled", label: "Schedule" },
    { id: 3, value: "Draft", label: "Draft" },
]

export const invoiceStatusObject = {
    overdue: "Overdue", unpaid: "Unpaid", paid: "Paid", partially_Paid: "Partially_Paid", public: "Publish", draft: "Draft"
}
export const getBillStatus = [
    { id: 1, value: "Unpaid", label: "Unpaid" },
    { id: 2, value: "Paid", label: "Paid" },
    { id: 3, value: "Overdue", label: "Overdue" },
    { id: 4, value: "Partially_Paid", label: "Partially Paid" },

]

export const invoiceType = ["Publish", "Draft"]
export const getNewsLetterStatus = (status) => {
    switch (status) {
        case newLetterStatus.sent:
            return "#6BC445";

        case newLetterStatus.draft:
            return "#FE7743";
        case newLetterStatus.scheduled:
            return "#FF9F00";
        default:
            return "default";
    }
};
export const leaveStatus = {
    approved:
        "APPROVED",
    rejected:
        "REJECTED",
    pending:
        "PENDING"
}
export const getLeaveStatus = (status) => {
    switch (status) {

        case "APPROVED":
            return "#6BC445";

        case "REJECTED":
            return "#EB4C4C";

        default:
            return "#3B4953";
    }
};

export const getMealStatus = (status) => {
    switch (status) {
        case mealStatus.Completed:
            return "#6BC445";
        case mealStatus.Active:
            return "#6E8CFB";
        case mealStatus.Scheduled:
            return "#FF9F00";
        default:
            return "default"; // fallback
    }
};


export const getInvoiceStatus = (status) => {
    switch (status) {
        case invoiceStatusObject.draft:
            return "#FFA239";
        case invoiceStatusObject.public:
            return "#0BA6DF";
        case invoiceStatusObject.unpaid:
            return "#3B4953"; // antd built-in green
        case invoiceStatusObject.paid:
            return "#6BC445";
        case invoiceStatusObject.partially_Paid:
            return "#FFA239";
        case invoiceStatusObject.overdue:
            return "#FF3838";
        default:
            return "default"; // fallback
    }
};

export const getCurriculumStatus = (status) => {
    switch (status) {
        case curriculumTypeData.completed:
            return "#6BC445";
        case curriculumTypeData.drafted:
            return "#FF9F00";
        case curriculumTypeData.planned:
            return "#6E8CFB";
        default:
            return "default"; // fallback
    }
};
export const getStatus = (status) => {
    switch (status) {
        case newStatus.Active:
            return "#6BC445";
        case newStatus.waitlist:
            return "#FA891A";
        case newStatus.Inactive:
            return "#ED3F27";
        case newStatus.active:
            return "#6BC445"; // antd built-in green
        case newStatus.inactive:
            return "#ED3F27";
        default:
            return "default"; // fallback
    }
};

export const staffParams = {
    shift: "shifts",
    staff: "staff-management",
    timeStamp: "timeStamps",
    role: "assignRoles",
    attendence: "staff-attendence"

}

export const attendanceFilter = ['today', 'weekly', 'monthly',]

export const mealsTypes = [
    { key: "1", label: "Meal List", },
    { key: "2", label: "Dietary Restrictions", },

];

export const hrPayrollStatus = {
    DRAFT: 'Draft',
    PROCESSED: 'Processed',
    PAID: 'Paid',
    CANCELLED: 'Cancelled'
}

export const curriculumType = [
    { key: "1", value: "drafted", label: "Drafted" },
    { key: "2", value: "planned", label: "Planned" },
    { key: "3", value: "completed", label: "Completed" },
]

export const parentCurriculumType = [
    { key: "1", value: "planned", label: "Planned" },
    { key: "2", value: "completed", label: "Completed" },
]

export const curriculumTypeData = { drafted: "Drafted", planned: "Planned", completed: "Completed" }

export const mealsTime = [
    'Breakfast', 'Lunch', 'Dinner', 'Snack'
]

export const curriculumCategory = [
    "Cognitive Development",
    "Motor Skills",
    "Social & Emotional Skills",
    "Language & Literacy",
    "Numeracy Skills",
    "Creative Arts",
    "Science & Discovery",
    "Practical Life Skills",
    "Cultural Awareness",
    "Wellness & Mindfulness",
    "Outdoor Play",
    "Music & Rhythm",
    "STEM Exploration",
]

export const days = [
    "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"
]

export const enrolmentStatus = {
    active: "ACTIVE",
    inactive: "INACTIVE",
    waitlist: "WAITLIST"
};
export const enrollmentStatusData = [{ id: 1, value: "ACTIVE", label: "Active" }, { id: 2, value: "INACTIVE", label: "Inactive" }, { id: 3, value: "WAITLIST", label: "Waitlist" }]
export const getEnrollmentStatus = [
    { key: 1, value: enrolmentStatus.active, label: "Active" },
    { key: 2, value: enrolmentStatus.inactive, label: "Inactive" },
    { key: 3, value: enrolmentStatus.waitlist, label: "Waitlist" },
]

export const categoryTypes = {
    learning: "Learning",
    video: "Video",
    photo: "Photo",
    mood: "Mood",
    curriculum: "Curriculum",
    nap: "Nap",
    leave: "LeaveType",
    incidentType: "IncidentType",
    staffDocuments: "StaffDocuments",
    studentDocuments: "StudentDocuments",
}

export const documentStatus = [
    "Rejected",
    "Pending",
    "Approved"
];

export const getDocumentStatus = (status) => {
    switch (status) {
        case "Approved":
            return "#6BC445";
        case "Rejected":
            return "#ED3F27";

        default:
            return "#777C6D";
    }
};

export const getHrPayrollStatusColor = (status) => {
    switch (status) {
        case hrPayrollStatus.DRAFT.toUpperCase():
            return "#FFB800"; // Gray

        case hrPayrollStatus.PROCESSED.toUpperCase():
            return "#6E8CFB"; // Yellow

        case hrPayrollStatus.PAID.toUpperCase():
            return "#6BC445"; // Green

        case hrPayrollStatus.CANCELLED.toUpperCase():
            return "#ED3F27"; // Red

        default:
            return "#777C6D";
    }
};


export const docTypes = [
    { id: 1, value: "children", label: "Children" },
    { id: 2, value: "staffs", label: "Staffs" },

];

// activity dropdown

export const activityMealType = ["Breakfast", "Lunch", "Snack", "Dinner"]
export const quantityEatenType = ["All", "Half", "Few Bites", "None"]
export const hydrationType = ["Water", "Milk", "Juice"]
export const sleepQualityType = ["Deep", "Light", "Interrupted"]
export const bathroomTypes = ["Urine", "Stool", "Both"]
export const Bottlequantity = ["ml", "oz"]
export const NotePriority = ["Normal", "Important"]
export const firstAidOption = ["Yes", "No"]
export const staffGender = ["Male", "Female", "Other"]
export const getEmploymentStatus = ["Active", "Inactive",]
export const getChildAttendence = ["Attendance", "Daily Reports"]
export const getStaffAttendence = ["Attendance", "Leaves", "Shift Schedule"]
export const getAttendenceLeave = ["Attendance", "Leaves"]

export const staffAccessModule = {
    children: "Children",
    staff: "Staff",
    room: "Rooms",
    curriculum: "Curriculum",
    leaveRequest: "Leave Request",
    document: "Documents",
    meals: "Meals",
    activities: "Activity",
    incidents: "Incident And Behavior",
    attendance: "Attendance",
    events: "Event",
    newsletters: "Newsletter",
    billing: "Billing",
    reports: "Reports",
    message: "Message",
    hrPayrol: "HR(Payroll)",
    kiosk: "Sign In Kiosk",
}
export const staffAccessAction = {
    view: "view",
    edit: "edit",
    delete: "delete",
    add: "add"
}
export const getChildAttend = [
    { id: 1, value: "today", label: "Today" },
    { id: 2, value: "weekly", label: "Weekly" },
    { id: 3, value: "monthly", label: "Monthly" },
    
]

export const incidentStatusType = (status) => {
    switch (status) {
        case "ASSIGNED_TO_STAFF":
            return "#6E8CFB";
        case "SUBMITTED_TO_MANAGER":
            return "#FF9F00";
        case "STAFF_COMPLETED":
            return "#B35656";
        case "MANAGER_APPROVED":
            return "#6BC445";
        case "COMPLETED":
            return "#48A111";
        case "SENT_TO_PARENT":
            return "#3B7597";
        default:
            return "default";
    }
};


export const indicatorType = {
    event: "event", curriculum: "curriculum", news: "newsletter", activity: "activity"
}